import { Component, input } from '@angular/core';
import { BaseConfig } from '../common/config/config.adapter';

@Component({
  selector: 'lepi-text-field',
  template: `
    <div class="flex flex-col gap-3">
      <p class="font-semibold theme-text">
        {{ label() }}
      </p>
      <p class="break-all text-gray-500">
        <ng-content />
      </p>
    </div>
  `,
  imports: [],
})
export class TextField extends BaseConfig {
  label = input.required<string>();
}
